// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { AddressInfoDisplayStyles } from "@keller/Overrides/Components/AddressInfoDisplay";
import { color } from "@keller/XDL/Utilities";
import { css } from "styled-components";

interface SharedAddressesStyles {
    container?: GridContainerProps;
    headingGridItem?: GridItemProps;
    headingText?: TypographyPresentationProps;
    addressDisplayGridItem?: GridItemProps;
    addressFormGridItem?: GridItemProps;
}

interface ReviewSharedAddressesStyles {
    container?: GridContainerProps;
    headingGridItem?: GridItemProps;
    heading?: TypographyPresentationProps;
    editLink?: LinkPresentationProps;
    addressGridItem?: GridItemProps;
    address?: AddressInfoDisplayStyles;
}

const sharedAddressesStyles: SharedAddressesStyles = {
    container: { gap: 0 },
    headingGridItem: {
        width: 12,
        css: css`
            &&&& {
                margin-bottom: 16px;
            }
        `,
    },
    headingText: {
        variant: "h5",
        css: css`
            letter-spacing: 0;
            margin-bottom: 0;
        `,
    },
    addressDisplayGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
            border: 1px solid ${color("common.ui5")};
            border-radius: 4px;
            background-color: ${color("common.white")};
            box-shadow: 0 2px 0 0 ${color("common.ui5")};
            padding: 16px;
        `,
    },
    addressFormGridItem: {
        width: 12,
        css: css`
            &&&& {
                margin-top: 20px;
            }
        `,
    },
};

export const reviewSectionAddressesStyles: ReviewSharedAddressesStyles = {
    container: { gap: 16 },
    headingGridItem: {
        width: 12,
    },
    heading: {
        size: 14,
        weight: "bold",
        css: css`
            letter-spacing: 0;
            line-height: 19px;
        `,
    },
    editLink: {
        css: css`
            display: none;
        `,
    },
    address: {
        companyNameText: {
            size: 12,
            weight: "bold",
            css: css`
                letter-spacing: 0;
                line-height: 18px;
                margin-bottom: 8px;
            `,
        },
    },
};

export default sharedAddressesStyles;
